import {Button} from 'antd';
import React from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';
import {CustomSelect} from 'components/form/inputs/custom-select';
import {ITableReportProps} from 'components/table-report/table-report-types';
import {IControlRatioCalculationDto, IControlRatioStatisticDto} from 'features/calculate-control-ratios/model/types';
import {ILookupEntry} from 'shared/types/lookups';
import {formatDate} from 'shared/utils/date-time';

import {getLookupValue} from '../../lib/get-lookup-value';
import {ControlRatiosStatisticModal} from '../modals/control-ratios-statistic-modal';
import s from './columns.module.less';

export const CONTROL_RATIOS_CALCULATION_TABLE_COLUMNS: IUseCustomTableArgs['columns'] = [
    {
        dataIndex: 'description',
        key: 'description',
        title: 'Контрольное соотношение',
        width: '300px',
        align: 'center',
    },
    {
        dataIndex: 'existsParentCalculation',
        key: 'existsParentCalculation',
        title: 'Расчет родительской части',
        width: '150px',
        align: 'center',
    },
    {
        dataIndex: 'existsChildCalculation',
        key: 'existsChildCalculation',
        title: 'Расчет дочерней части',
        width: '150px',
        align: 'center',
    },
    {
        dataIndex: 'resultValue',
        key: 'resultValue',
        title: 'Расхождение',
        width: '150px',
        align: 'center',
        render: (v, row: IControlRatioCalculationDto) => (
            row.existsDiscrepancy !== null ? (
                <div className={s[`text-${row.existsDiscrepancy ? 'negative' : 'positive'}`]}>
                    {v}
                </div>
            )
                : '—'
        ),

    },
    {
        dataIndex: 'status',
        key: 'status',
        title: 'Результат',
        width: '150px',
        align: 'center',
    },
];
interface IControlRatiosTableColumnsGetterArgs {
  docId: ITableReportProps['docId'];
  handleRowUpdate: (oldLookupCode: string, newLookupCode: string) => void;
  handleCalculateCR: (childDocId: ITableReportProps['docId']) => Promise<void>;
}

export const getControlRatiosTableColumns = ({
    docId,
    handleRowUpdate,
    handleCalculateCR,
}: IControlRatiosTableColumnsGetterArgs): IUseCustomTableArgs['columns'] => [
    {
        dataIndex: 'docTypeName',
        key: 'docTypeName',
        title: 'Тип документа',
        width: '250px',
        align: 'center',
    },
    {
        dataIndex: 'document',
        key: 'document',
        title: 'Название документа',
        width: '200px',
        align: 'center',
        render: (v: Pick<ILookupEntry, 'lookupCode' | 'meaning'>, row: IControlRatioStatisticDto) => (
            <CustomSelect
                value={v.lookupCode}
                entries={row.documentLookups.map(l => ({label: l.meaning, value: l.lookupCode}))}
                onChange={newValue => handleRowUpdate(v.lookupCode, newValue)}
                style={{width: '200px'}}
                settings={{
                    showSearch: true,
                }}
            />
        ),
    },
    {
        dataIndex: 'createdDate',
        key: 'createdDate',
        title: 'Дата загрузки документа',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => formatDate(getLookupValue(row, 'createdDate')),
    },
    {
        dataIndex: 'author',
        key: 'author',
        title: 'Автор документа',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => getLookupValue(row, 'author'),
    },
    {
        dataIndex: 'version',
        key: 'version',
        title: 'Версия документа',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => getLookupValue(row, 'version'),
    },
    {
        dataIndex: 'status',
        key: 'status',
        title: 'Статус документа',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => getLookupValue(row, 'status'),
    },
    {
        dataIndex: 'corrNum',
        key: 'corrNum',
        title: 'Номер корректировки',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => getLookupValue(row, 'corrNum'),
    },
    {
        dataIndex: 'ifns',
        key: 'ifns',
        title: 'ИФНС',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => getLookupValue(row, 'ifns'),
    },
    {
        dataIndex: 'branchName',
        key: 'branchName',
        title: 'Филиал',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => getLookupValue(row, 'branchName'),
    },
    {
        dataIndex: 'statistic',
        key: 'statistic',
        title: 'Статистика контрольных соотношений',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => {
            const statistic = getLookupValue(row, 'statistic');

            return statistic && (
                <ControlRatiosStatisticModal
                    buttonLabel={statistic}
                    parentDocId={docId}
                    childDocId={row.document.lookupCode}
                />
            );
        },
    },
    {
        dataIndex: 'docNameLookups.calculateCR',
        key: 'docNameLookups.calculateCR',
        title: 'Рассчитать КС',
        width: '150px',
        align: 'center',
        render: (_, row: IControlRatioStatisticDto) => (
            <Button
                type="link"
                onClick={() => handleCalculateCR(row.document.lookupCode)}
            >
                Рассчитать КС
            </Button>
        ),
    },
];
